export const formatNumber = (number: number | string, decimals = 2, commaForThousands = true, signed = false) => {
  const num = typeof number === 'string' ? parseFloat(number) : number;
  if (isNaN(num)) {
    return '0.00';
  }

  const fixedNumber = num.toFixed(decimals);
  if (!commaForThousands && !signed) {
    return fixedNumber;
  }

  let res = fixedNumber;
  if (commaForThousands) {
    const parts = fixedNumber.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    res = parts.join('.');
  }

  if (signed) {
    res = (num >= 0 ? '+' : '') + res;
  }
  return res;
};
